import { j as o } from "../jsx-runtime-ClSzPYp4.js";
import { Box as n } from "../Flexbox/Flexbox.mjs";
const x = ({ bg: t, children: e, ...s }) => /* @__PURE__ */ o.jsx(n, {
  as: "section",
  width: 1,
  bg: t,
  ...s,
  children: e
}), m = ({ bg: t = "global.transparent", children: e, maxWidth: s = "eightColumn", ...l }) => /* @__PURE__ */ o.jsx(n, {
  py: [
    "lg",
    null,
    "xl"
  ],
  px: [
    "sm",
    null,
    "lg"
  ],
  width: 1,
  my: 0,
  mx: "auto",
  bg: t,
  maxWidth: s,
  ...l,
  children: e
}), r = ({ children: t, contentBg: e, maxWidth: s = "eightColumn", OuterWrapper: l = x, wrapperBg: a, wrapperProps: g, ...p }) => /* @__PURE__ */ o.jsx(l, {
  bg: a,
  ...g,
  children: /* @__PURE__ */ o.jsx(m, {
    maxWidth: s,
    bg: e,
    children: t,
    ...p
  })
}), w = ({ cutoutHeight: t = "-5rem", children: e, ...s }) => /* @__PURE__ */ o.jsx(r, {
  mt: [
    0,
    t
  ],
  py: [
    "sm",
    "sm"
  ],
  pb: [
    "md",
    "lg"
  ],
  contentBg: "global.white",
  ...s,
  children: e
}), i = (t) => /* @__PURE__ */ o.jsx(n, {
  as: "section",
  px: [
    "sm",
    0,
    "lg"
  ],
  ...t
}), P = (t) => /* @__PURE__ */ o.jsx(r, {
  OuterWrapper: i,
  px: [
    0,
    "lg",
    0
  ],
  ...t
}), c = (t) => /* @__PURE__ */ o.jsx(n, {
  as: "section",
  px: [
    "sm",
    0,
    "lg"
  ],
  flexGrow: 1,
  ...t
}), d = (t) => /* @__PURE__ */ o.jsx(r, {
  OuterWrapper: c,
  px: [
    0,
    "lg",
    0
  ],
  ...t
});
export {
  x as DefaultOuterWrapper,
  r as PageRow,
  m as PageRowContent,
  d as PageRowFullHeight,
  P as PageRowNoContentPadding,
  w as PageRowTopOverlay
};
